import React, { useState, useEffect } from "react";
import {
    Box,
    Grid,
    Button,
    TextField,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Checkbox,
} from "@mui/material";
import {
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon,
} from "@mui/icons-material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../../lib/axios";

const RefundStep2 = ({
    TableData,
    formData1,
    setFormData,
    ResidentId,
    IsButtonSubmit,
    AllButtonDisabledOuter,
    handleCancel,
    fetchRefundData,
    setPytId,
    PytId,
    handleStepClick,
}) => {
    const [formData, setformData] = useState({
        RcdAmt: 0,
        PytAmt:0,
        AgstBill: 0,
        Amount: 0,
        PytAdvAmount: 0,
        BalAmt: 0,
        Remark: "",
    });
    const [AllTextDisabled, setAllTextDisabled] = useState(true);
    const [AllButtonDisabled, setAllButtonDisabled] = useState(true);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");
    const [tableData, setTableData] = useState([]);
    const [fetchedData, setFetchedData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [editedRow, setEditedRow] = useState(null);
    const currentDate = new Date().toISOString().split("T")[0];
    const [originalFetchedData, setOriginalFetchedData] = useState([]);
    const [totalSelectedBalAmt, setTotalSelectedBalAmt] = useState(0);
    const [totalSelectedRcdAmt, setTotalSelectedRcdAmt] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);


    const columns = [
        { id: "BookNo", label: "BookNo", minWidth: 50 },
        { id: "CnNo", label: "CreditNo", minWidth: 50 },
        { id: "DocAdvDt", label: "DocDt", minWidth: 50 },
        { id: "PytAdvAmt", label: "DocAmt", minWidth: 50 },
        { id: "Amount", label: "PytAmt", minWidth: 50 },
        { id: "BalAmt", label: "BalAmt", minWidth: 50 },
        { id: "DBFLAG", label: "Flag", minWidth: 50 },
        { id: "Remark", label: "Remark", minWidth: 50 },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newBalAmt = formData.BalAmt;
        if (name === "Amount" || name === "PytAdvAmount") {
            const updatedFormData = {
                ...formData,
                [name]: value,
            };
            if (updatedFormData.PytAdvAmount && updatedFormData.Amount) {
                newBalAmt = parseFloat(updatedFormData.PytAdvAmount) - parseFloat(updatedFormData.Amount);
            }
            setformData({
                ...updatedFormData,
                BalAmt: isNaN(newBalAmt) ? 0 : newBalAmt,
            });
        } else {
            setformData({
                ...formData,
                [name]: value,
            });
        }
    };

    const fetchData = async (residentId, pytId) => {
        try {
            console.log("Fetching data with:", { ResidentId: residentId, PytId: pytId });
            const payload = {
                PytId: pytId > 0 ? pytId : 0,
                Flag: "",
                ResidentId: residentId,
                PropId:formData1.PropId
            };
            console.log("API Payload:", payload);
            const response = await axiosInstance.post("TrnPytvchr/GetTrnPytdtlAll", payload);
            console.log("API Response:", response.data);
            if (response?.data?.Data && Array.isArray(response.data.Data) && response.data.Data.length > 0) {
                const filteredFetchedData = response.data.Data.filter(
                    (row) =>
                        !tableData.some(
                            (existingRow) =>
                                existingRow.PytAdvNo === row.PytAdvNo &&
                                (existingRow.DBFLAG === "I" || existingRow.DBFLAG === "R")
                        )
                );
                console.log("Filtered Fetched Data:", filteredFetchedData);
                setFetchedData(filteredFetchedData);
                setOriginalFetchedData(filteredFetchedData);
            } else {
                setFetchedData([]);
                setOriginalFetchedData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            console.error("Error details:", error.response?.data || error.message);
            toast.error("Failed to fetch data. Please check the network or API configuration.");
            setFetchedData([]);
            setOriginalFetchedData([]);
        }
    };

    const handleAddClick2 = () => {
        console.log("Add button clicked:", { ResidentId, PytId });
        if (ResidentId && PytId) {
            fetchData(ResidentId, PytId);
            setOpenDialog(true);
        } else {
            toast.error("ResidentId or PytId is missing");
        }
    };

    const handleCheckboxChange = (event, row) => {
        let updatedSelectedRows = [...selectedRows];
        if (event.target.checked) {
            updatedSelectedRows.push(row);
        } else {
            updatedSelectedRows = updatedSelectedRows.filter(
                (selectedRow) => selectedRow.PytAdvNo !== row.PytAdvNo
            );
        }
        setSelectedRows(updatedSelectedRows);
        const totalBalAmt = updatedSelectedRows.reduce(
            (total, row) => total + parseFloat(row.BalAmt || 0),
            0
        );
        const totalRcdAmt = updatedSelectedRows.reduce(
            (total, row) => total + parseFloat(row.Amount || 0),
            0
        );
        setTotalSelectedBalAmt(totalBalAmt);
        setTotalSelectedRcdAmt(totalRcdAmt);
    };

    useEffect(() => {
        if (formData1?.TrnPytDtlEntity && formData1.TrnPytDtlEntity.length > 0) {
            if (tableData.length === 0) {
                setTableData(formData1.TrnPytDtlEntity);
            }
        }
    }, [formData1]);

    useEffect(() => {
        const allData = [
            ...(formData1?.TrnPytDtlEntity || []).filter((row) => row.DBFLAG !== "D"),
            ...tableData.filter(
                (row) =>
                    row.DBFLAG !== "D" &&
                    !formData1?.TrnPytDtlEntity?.some(
                        (existingRow) => existingRow.PytAdvNo === row.PytAdvNo
                    )
            ),
        ];
        const totalAmount = allData
            .reduce((total, row) => total + parseFloat(row.Amount || 0), 0)
            ?.toFixed(2);
        setFormData({
            ...formData1,
            AgstBill: totalAmount,
            PytAmt:
                parseFloat(formData1.PytAmt || 0) === 0 ? totalAmount : formData1.PytAmt,
        });
    }, [tableData, formData1?.TrnPytDtlEntity, setFormData]);

    const handleConfirmSelection = () => {
        if (selectedRows.length === 0) {
            toast.error("Please select a record.");
            return;
        }
        const newTableData = [...tableData];
        selectedRows.forEach((row) => {
            if (!newTableData.some((existingRow) => existingRow.PytAdvNo === row.PytAdvNo)) {
                const newRow = {
                    ...row,
                    Amount: row.BalAmt,
                    DBFLAG: "I",
                };
                newTableData.push(newRow);
            } else {
                toast.warning(`PytAdvNo ${row.PytAdvNo} is already added.`);
            }
        });
        setTableData(newTableData);
        setOpenDialog(false);
        setSelectedRows([]);
        const updatedFetchedData = fetchedData.filter(
            (row) =>
                !selectedRows.some((selectedRow) => selectedRow.PytAdvNo === row.PytAdvNo)
        );
        setFetchedData(updatedFetchedData);
        if (!formData1.PytAmt || formData1.PytAmt === 0) {
            const totalAmount = calculateTotalAmount();
            setFormData({
                ...formData1,
                PytAmt: totalAmount,
                AgstBill: totalAmount,
            });
        }
    };

    const calculateTotalAmount = () => {
        const uniqueRows = [];
        const processedPytAdvNos = new Set();
        if (formData1?.TrnPytDtlEntity && formData1.TrnPytDtlEntity.length > 0) {
            formData1.TrnPytDtlEntity.forEach((row) => {
                if (!processedPytAdvNos.has(row.PytAdvNo) && row.DBFLAG !== "D") {
                    uniqueRows.push(row);
                    processedPytAdvNos.add(row.PytAdvNo);
                }
            });
        }
        tableData.forEach((row) => {
            if (!processedPytAdvNos.has(row.PytAdvNo) && row.DBFLAG !== "D") {
                uniqueRows.push(row);
                processedPytAdvNos.add(row.PytAdvNo);
            }
        });
        return uniqueRows
            .reduce((total, row) => total + parseFloat(row.Amount || 0), 0)
            ?.toFixed(2);
    };

    const combinedData = (() => {
        const uniqueRows = [];
        const processedPytAdvNos = new Set();
        if (formData1?.TrnPytDtlEntity && formData1.TrnPytDtlEntity.length > 0) {
            formData1.TrnPytDtlEntity.forEach((row) => {
                if (!processedPytAdvNos.has(row.PytAdvNo) && row.DBFLAG !== "D") {
                    uniqueRows.push(row);
                    processedPytAdvNos.add(row.PytAdvNo);
                }
            });
        }
        tableData.forEach((row) => {
            if (!processedPytAdvNos.has(row.PytAdvNo) && row.DBFLAG !== "D") {
                uniqueRows.push(row);
                processedPytAdvNos.add(row.PytAdvNo);
            }
        });
        return uniqueRows;
    })();

const handleSubmit = async () => {
    try {
        setIsSubmitting(true);
        const totalAmount = parseFloat(calculateTotalAmount());
        const enteredRcdAmt = parseFloat(formData1.PytAmt || 0);

        if (enteredRcdAmt < totalAmount) {
            toast.error("Received amount is less than the Total BalAmt.");
            localStorage.setItem("focusRcdAmt", "true");
            handleStepClick(0);
            return;
        }
        if (enteredRcdAmt === 0) {
            toast.error("Payment amount cannot be zero.");
            localStorage.setItem("focusRcdAmt", "true");
            handleStepClick(0);
            return;
        }
        const allCurrentRecords = [
            ...(formData1?.TrnPytDtlEntity || []).filter((row) => row.DBFLAG !== "D"),
            ...tableData.filter(
                (row) =>
                    row.DBFLAG !== "D" &&
                    !formData1?.TrnPytDtlEntity?.some(
                        (existingRow) => existingRow.PytAdvNo === row.PytAdvNo
                    )
            ),
        ];

        const formatDate = (date) => {
            if (!date) return new Date().toISOString();
            const d = new Date(date);
            return isNaN(d.getTime()) ? new Date().toISOString() : d.toISOString();
        };

        const userId = sessionStorage.getItem("UserId") || 1;
        const currentDate = new Date().toISOString();

        const isUpdate = formData1.PytId && formData1.PytId > 0;
        const trnPytDtlEntities = allCurrentRecords.map((row) => {
            const isExistingRecord = row.PytdtlId && row.PytdtlId > 0;
            const isFromOriginalData = formData1?.TrnPytDtlEntity?.some(
                existingRow => existingRow.PytAdvNo === row.PytAdvNo
            );

            let dbFlag = "I"; 
            
            if (isUpdate && isExistingRecord) {
                dbFlag = "U";
            } else if (row.DBFLAG) {
                dbFlag = row.DBFLAG;
            } else if (isUpdate && isFromOriginalData) {
                dbFlag = "U";
            }

            return {
                PytdtlId: row.PytdtlId || 0,
                PytId: isUpdate ? formData1.PytId : 0,
                PytAdvId: row.PytAdvId || 0,
                ChkOutStlId: row.ChkOutStlId || 1,
                CnId: row.CnId,
                PytAdvAmt: parseFloat(row.PytAdvAmount) || 0,
                BalAmt: parseFloat(row.BalAmt) || 0,
                Amount: parseFloat(row.Amount) || 0,
                DiscAmt: parseFloat(row.DiscAmt) || 0,
                NetAmt: parseFloat(row.NetAmt || row.Amount) || 0,
                Remark: row.Remark || "",
                BookId: row.BookId || 0,
                PropId: row.PropId || (formData1.PropId || 2),
                PytFlag: row.PytFlag || "",
                DBFLAG: dbFlag,
               
            };
        });

        const payload = [{
            PytId: isUpdate ? formData1.PytId : 0,
            PytNo: formData1.PytNo || "",
            PytDt: formatDate(formData1.PytDt) || currentDate,
            PropId: formData1.PropId || 2,
            ResidentId: formData1.ResidentId || 0,
            PytFlag: formData1.PytFlag || "R",
            AccLedId: formData1.AccLedId || 1,
            PytVchrRef: formData1.PytVchrRef || "",
            PytAmt: parseFloat(formData1.PytAmt) || 0,
            AgstBill: parseFloat(formData1.AgstBill || totalAmount) || 0,
            OnacAmt: parseFloat(formData1.OnacAmt) || 0,
            OnacBal: parseFloat(formData1.OnacBal) || 0,
            Pyttype: formData1.Pyttype || "OffLine",
            PytMode: formData1.PytMode || "Cash",
            TrjId: formData1.TrjId || "1",
            ChequeNo: formData1.ChequeNo || "",
            ChqInfvr: formData1.ChqInfvr || "",
            ChqDt: formatDate(formData1.ChqDt) || currentDate,
            ClgDt: formatDate(formData1.ClgPytDt) || currentDate,
            BankName: formData1.BankName || "",
            CardNo: formData1.CardNo || "",
            PartyId: formData1.PartyId || 1,
            PartyDtlId: formData1.PartyDtlId || 1,
            Status: formData1.Status || "1",
            Remark: formData1.Remark || "",
            DBFLAG: isUpdate ? "U" : "I",
            TrnPytDtlEntity: trnPytDtlEntities
        }];
     
        const response = await axiosInstance.post(
            "TrnPytvchr/ManageTrnPytvchr",
            payload
        );

        if (response?.data?.Status === 0) {
              const newPytId = parseInt(response.data.Data || 0);
            if (payload[0].DBFLAG === "I") {
                toast.success("Data inserted successfully");
                const id = parseInt(response.data?.Data || 0);
                console.log('iddddd'.id)
                 setPytId(newPytId);
            } else {
                toast.success(response.data.Message || "Data updated successfully");
            }
             if (newPytId > 0) {
                fetchRefundData(newPytId,"N");
            } else {
                fetchRefundData(PytId,"N");
            }
            setAllButtonDisabled(false);
            handleStepClick(0);
        } else {
            toast.error(response.data.Message || "Error submitting data.");
        }
    } catch (error) {
        console.error("Submission error:", error);
        console.log("Error response:", error.response?.data);
        toast.error("An error occurred during submission.");
        if (error.response) {
            toast.error(`Request failed: ${error.response.data?.message || "Unknown error"}`);
        } else {
            toast.error(`Network error: ${error.message}`);
        }
    } finally {
        setIsSubmitting(false);
    }
};

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const formatValue = (value, columnId) => {
        if (
            columnId.toLowerCase().includes("dt") &&
            (value instanceof Date || !isNaN(Date.parse(value)))
        ) {
            return formatDate(value);
        }
        if (typeof value === "string") return value || "N/A";
        if (typeof value === "number")
            return value === 0 ? "0.00" : value.toFixed(2);
        return value || "";
    };

    const handleRowClick = (row) => {
        console.log('row',row)
        setEditedRow(row);
        setformData({
            Amount: row.Amount || "",
            BalAmt: row.BalAmt || "",
            PytAdvAmount: row.PytAdvAmount || "",
            Remark: row.Remark || "",
        });
        setAllButtonDisabled(false);
    };

    const handleConfirmEdit = () => {
        if (!editedRow) {
            toast.error("Please select a row to edit.");
            return;
        }
        const formAmount = parseFloat(formData.Amount || 0);
        const balanceAmount = parseFloat(formData.PytAdvAmount || 0);
        if (isNaN(formAmount) || isNaN(balanceAmount)) {
            toast.error("Invalid Amount or Balance Amount.");
            return;
        }
        // if (formAmount > balanceAmount) {
        //     toast.error("Amount cannot achieve balance Amount.");
        //     return;
        // }
        const isFromTrnPytDtlEntity = formData1?.TrnPytDtlEntity?.some(
            (row) => row.PytAdvNo === editedRow.PytAdvNo
        );
        if (isFromTrnPytDtlEntity) {
            const updatedTrnPytDtlEntity = formData1.TrnPytDtlEntity.map((row) =>
                row.PytAdvNo === editedRow.PytAdvNo
                    ? {
                        ...row,
                        PytAdvAmount: formData.PytAdvAmount,
                        Amount: formData.Amount,
                        BalAmt: formData.BalAmt,
                        Remark: formData.Remark,
                        DBFLAG: "U",
                    }
                    : row
            );
            setFormData({
                ...formData1,
                TrnPytDtlEntity: updatedTrnPytDtlEntity,
            });
        }
        const updatedTableData = tableData.map((row) =>
            row.PytAdvNo === editedRow.PytAdvNo
                ? {
                    ...row,
                    PytAdvAmount: formData.PytAdvAmount,
                    Amount: formData.Amount,
                    BalAmt: formData.BalAmt,
                    Remark: formData.Remark,
                    DBFLAG: row.DBFLAG === "I" ? "I" : "U",
                }
                : row
        );
        setTableData(updatedTableData);
        setEditedRow(null);
        setformData({
            Amount: "",
            PytAmt:"",
            RcdAmt: "",
            PytAdvAmount: "",
            BalAmt: "",
            Remark: "",
        });
        setAllTextDisabled(true);
        setAllButtonDisabled(true);
    };

    const handleCancelEdit = () => {
        setEditedRow(null);
        setformData({
            Amount: "",
            PytAdvAmount: "",
            RcdAmt: "",
            PytAmt:"",
            BalAmt: "",
            Remark: "",
        });
        setAllTextDisabled(true);
        setAllButtonDisabled(true);
    };

    const handleClickEdit = () => {
        if (editedRow) {
            setAllTextDisabled(false);
        } else {
            toast.error("Please select a row to edit.");
        }
    };

    const handleDelete = () => {
        if (!editedRow) {
            toast.error("Please select a row to delete.");
            return;
        }
        if (!formData1 || !formData1.TrnPytDtlEntity) {
            const filteredTableData = tableData.filter(
                (row) => row.PytAdvNo !== editedRow.PytAdvNo
            );
            setTableData(filteredTableData);
            toast.success("Record deleted successfully.");
            setEditedRow(null);
            setformData({
                Amount: "",
                PytAdvAmount: "",
                RcdAmt: "",
                PytAmt:"",
                BalAmt: "",
                Remark: "",
            });
            setAllTextDisabled(true);
            setAllButtonDisabled(true);
            return;
        }
        const updatedData = tableData.map((row) =>
            row.PytAdvNo === editedRow.PytAdvNo
                ? {
                    ...row,
                    DBFLAG: row.DBFLAG === "I" ? "I" : "D",
                }
                : row
        );
        const updatedTrnPytDtlEntity = formData1.TrnPytDtlEntity.map((row) =>
            row.PytAdvNo === editedRow.PytAdvNo
                ? {
                    ...row,
                    DBFLAG: row.DBFLAG === "I" ? "I" : "D",
                }
                : row
        );
        setFormData({
            ...formData1,
            TrnPytDtlEntity: updatedTrnPytDtlEntity,
        });
        const filteredTableData = updatedData.filter(
            (row) => row.PytAdvNo !== editedRow.PytAdvNo
        );
        setTableData(filteredTableData);
        toast.success("Record marked for deletion.");
        setEditedRow(null);
        setformData({
            Amount: "",
            PytAdvAmount: "",
            RcdAmt: "",
            BalAmt: "",
            Remark: "",
        });
        setAllTextDisabled(true);
        setAllButtonDisabled(true);
    };

    const handlePrev = () => {
        const updatedFormData = {
            ...formData1,
            TrnPytDtlEntity: tableData.length > 0 ? tableData : formData1?.TrnPytDtlEntity || [],
        };
        setFormData(updatedFormData);
        handleStepClick(0);
    };

    const handleCancelsecond = () => {
        setSelectedRows([]);
        setTotalSelectedBalAmt(0);
        setTotalSelectedRcdAmt(0);
        setOpenDialog(false);
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Paper
                    sx={{
                        width: "90%",
                        overflow: "hidden",
                        margin: "0px 0px 0px 50px",
                        border: "1px solid lightgray",
                    }}
                >
                    <TableContainer sx={{ maxHeight: 450 }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow sx={{ "& > th": { padding: "2px 10px" } }}>
                                    {columns.map((column) => (
                                        <TableCell
                                            key={column.id}
                                            align={column.align}
                                            style={{ minWidth: column.minWidth }}
                                        >
                                            <Typography variant="subtitle1" fontWeight="bold">
                                                {column.label}
                                            </Typography>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {combinedData.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={columns.length} align="center">
                                            No records found
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    combinedData.map((row, index) => (
                                        <TableRow
                                            hover
                                            key={index}
                                            sx={{
                                                "& > td": { padding: "2px 15px" },
                                                cursor: IsButtonSubmit ? "not-allowed" : "pointer",
                                                opacity: IsButtonSubmit ? 0.5 : 1,
                                            }}
                                            onClick={() => (IsButtonSubmit ? null : handleRowClick(row))}
                                        >
                                            {columns.map((column) => (
                                                <TableCell key={column.id} align={column.align}>
                                                    {formatValue(row[column.id], column.id)}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Grid>

            <Grid
                item
                xs={12}
                sx={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    margin: "0px 0px 8px 0px",
                    paddingRight: "100px",
                }}
            >
                <Box sx={{ marginLeft: "50px" }}>
                    <Button
                        variant="contained"
                        size="small"
                        sx={{ backgroundColor: "#635bff" }}
                        onClick={handleAddClick2}
                        disabled={IsButtonSubmit}
                    >
                        <AddIcon />
                    </Button>
                    <Button
                        variant="contained"
                        size="small"
                        sx={{ backgroundColor: "#635bff", margin: "0px 10px" }}
                        disabled={AllButtonDisabled || !AllTextDisabled}
                        onClick={handleClickEdit}
                    >
                        <EditIcon />
                    </Button>
                    <Button
                        variant="contained"
                        size="small"
                        sx={{ backgroundColor: "#635bff" }}
                        disabled={AllButtonDisabled || !AllTextDisabled}
                        onClick={handleDelete}
                    >
                        <DeleteIcon />
                    </Button>
                </Box>
                <Box>
                    <Button
                        variant="contained"
                        size="small"
                        sx={{ backgroundColor: "#635bff" }}
                        disabled={AllTextDisabled}
                        onClick={handleConfirmEdit}
                    >
                        Confirm
                    </Button>
                    <Button
                        variant="contained"
                        size="small"
                        sx={{ backgroundColor: "#635bff", margin: "0px 10px" }}
                        disabled={AllTextDisabled}
                        onClick={handleCancelEdit}
                    >
                        Cancel
                    </Button>
                </Box>
                <Box
                    sx={{
                        padding: "8px 16px",
                        backgroundColor: "#f5f5f5",
                        borderRadius: "4px",
                        border: "1px solid #ddd",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        sx={{ marginRight: "8px" }}
                    >
                        Total PytAmt:
                    </Typography>
                    <Typography variant="h6" color="primary">
                        {calculateTotalAmount()}
                    </Typography>
                </Box>
            </Grid>

            {openDialog && (
                <Dialog
                    open={openDialog}
                    onClose={() => setOpenDialog(false)}
                    maxWidth="lg"
                    fullWidth
                >
                    <DialogTitle>Select Records</DialogTitle>
                    <DialogContent
                        sx={{
                            overflowY: "auto",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            paddingBottom: "10px",
                        }}
                    >
                        <TableContainer sx={{ mb: 1 }}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">
                                            <Checkbox
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setSelectedRows([...fetchedData]);
                                                        const totalBalAmt = fetchedData.reduce(
                                                            (total, row) => total + parseFloat(row.BalAmt || 0),
                                                            0
                                                        );
                                                        const totalRcdAmt = fetchedData.reduce(
                                                            (total, row) => total + parseFloat(row.Amount || 0),
                                                            0
                                                        );
                                                        setTotalSelectedBalAmt(totalBalAmt);
                                                        setTotalSelectedRcdAmt(totalRcdAmt);
                                                    } else {
                                                        setSelectedRows([]);
                                                        setTotalSelectedBalAmt(0);
                                                        setTotalSelectedRcdAmt(0);
                                                    }
                                                }}
                                                checked={
                                                    selectedRows.length > 0 &&
                                                    selectedRows.length === fetchedData.length
                                                }
                                                indeterminate={
                                                    selectedRows.length > 0 &&
                                                    selectedRows.length < fetchedData.length
                                                }
                                            />
                                            <span style={{ verticalAlign: "middle" }}>All</span>
                                        </TableCell>
                                        {columns.map((column) => (
                                            <TableCell key={column.id} align="center">
                                                <TextField
                                                    size="small"
                                                    variant="outlined"
                                                    fullWidth
                                                    placeholder={`${column.label}`}
                                                    onChange={(e) => {
                                                        const value = e.target.value.toLowerCase();
                                                        const filtered = originalFetchedData.filter((row) =>
                                                            String(row[column.id]).toLowerCase().includes(value)
                                                        );
                                                        setFetchedData(filtered);
                                                        if (!value) {
                                                            fetchData(ResidentId, PytId);
                                                        }
                                                    }}
                                                />
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                            </Table>
                        </TableContainer>

                        <TableContainer sx={{ maxHeight: "35vh", width: "100%" }}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Select</TableCell>
                                        {columns.map((column) => (
                                            <TableCell key={column.id} align="center">
                                                <Typography variant="subtitle2" fontWeight="bold">
                                                    {column.label}
                                                </Typography>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {fetchedData.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={columns.length + 1} align="center">
                                                No records found
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        fetchedData.map((row, index) => (
                                            <TableRow
                                                key={index}
                                                sx={{
                                                    "& > td": { padding: "2px 10px" },
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <TableCell align="center">
                                                    <Checkbox
                                                        onChange={(e) => handleCheckboxChange(e, row)}
                                                        checked={selectedRows.some(
                                                            (selectedRow) => selectedRow.PytAdvNo === row.PytAdvNo
                                                        )}
                                                    />
                                                </TableCell>
                                                {columns.map((column) => (
                                                    <TableCell key={column.id} align="center" sx={{ py: 0.5 }}>
                                                        {formatValue(row[column.id], column.id)}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <div
                            style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "0px",
                            }}
                        >
                            <div
                                style={{
                                    marginRight: "20px",
                                    padding: "10px",
                                    backgroundColor: "#f5f5f5",
                                    borderRadius: "5px",
                                    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                                    fontWeight: "bold",
                                    color: "#d32f2f",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <strong style={{ marginRight: "10px" }}>UnAllocated Amount:</strong>
                                <span>
                                    {typeof formData1.PytAmt === "number" && !isNaN(formData1.PytAmt)
                                        ? (formData1.RcdAmt - totalSelectedBalAmt)?.toFixed(2)
                                        : !isNaN(parseFloat(formData1.PytAmt))
                                            ? (parseFloat(formData1.PytAmt) - totalSelectedBalAmt)?.toFixed(2)
                                            : "N/A"}
                                </span>
                            </div>
                            <div
                                style={{
                                    padding: "10px",
                                    backgroundColor: "#e8f5e9",
                                    borderRadius: "5px",
                                    boxShadow: "0 2px 2px rgba(0, 0, 0, 0.1)",
                                    fontWeight: "bold",
                                    color: "#388e3c",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <strong style={{ marginRight: "10px" }}>Allocated Amount:</strong>
                                <span>{totalSelectedBalAmt?.toFixed(2)}</span>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions sx={{ marginTop: 0, paddingTop: "0" }}>
                        <Button
                            onClick={handleConfirmSelection}
                            color="primary"
                            disabled={selectedRows.length === 0}
                        >
                            Confirm
                        </Button>
                        <Button onClick={handleCancelsecond} color="secondary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            )}

            <Grid
                container
                spacing={1}
                sx={{
                    margin: "auto",
                    paddingLeft: "65px",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Grid container spacing={2}>
                    <Grid item lg={8} md={8} xs={12}>
                        <Box display="flex" flexDirection="column" gap={0.5}>
                            <Grid container spacing={0.5}>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth
                                        label="Pyt Amount"
                                        name="Amount"
                                        variant="filled"
                                        className="custom-textfield"
                                        disabled={AllTextDisabled}
                                        value={formData.Amount}
                                        onChange={handleChange}
                                        type="number"
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth
                                        label="Doc Amount"
                                        name="PytAdvAmount"
                                        variant="filled"
                                        className="custom-textfield"
                                        disabled
                                        value={formData.PytAdvAmount}
                                        onChange={handleChange}
                                        type="number"
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth
                                        label="Bal Amount"
                                        name="BalAmt"
                                        variant="filled"
                                        className="custom-textfield"
                                        disabled
                                        value={formData.BalAmt}
                                        onChange={handleChange}
                                        type="number"
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={0.5}>
                                <Grid item xs={12} md={12}>
                                    <TextField
                                        fullWidth
                                        label="Remark"
                                        name="Remark"
                                        variant="filled"
                                        className="custom-textfield"
                                        disabled={AllTextDisabled}
                                        value={formData.Remark}
                                        onChange={handleChange}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} className="form_button" gap="10px">
                {["Prev", "Submit", "Cancel"].map((label, index) => (
                    <Button
                        key={index}
                        sx={{
                            background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
                            width: "50px",
                        }}
                        variant="contained"
                        onClick={
                            label === "Submit"
                                ? handleSubmit
                                : label === "Cancel"
                                    ? handleCancel
                                    : handlePrev
                        }
                        disabled={label === "Submit" ? isSubmitting : !AllButtonDisabledOuter}
                    >
                        {label}
                    </Button>
                ))}
            </Grid>
        </Grid>
    );
};

export default RefundStep2;